// Vue:
import Vue from 'vue';

// Vue mixins:
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

// Vue directives:

// Vue components:
import { euiCollapsible } from 'v-components/euiCollapsible';
import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiMermeny from 'v-components/euiMermeny';

// Vue store:
import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(
import { mapState, mapGetters, mapMutations } from 'vuex';

// Övrigt:
import { ssoTooltips } from 'ssoTooltips';
import NavigatedWithBackOrForward from 'NavigatedWithBackOrForward';
import SetOrUpdateClassOnFirstAndLastNonHiddenChild from 'SetOrUpdateClassOnFirstAndLastNonHiddenChild';

import axios from 'axios';
import objectToFormData from 'object-to-formdata';
//import { Resultat } from 'classes/ResultatClasses';

import addPageAsWidget from 'ssoAddPageAsWidget';


//------------------------------------------------------------------------------------------------------------------------------

// Använd dessa Vue plugins:
Vue.use(euiCollapsible);

window.ssoAllaSidor = window.ssoAllaSidor || {};	// För att undvika ESLint-varningar att den är odefinierad.
window.ssoRapport = window.ssoRapport || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Fixa till sidans mermeny, så den är av rätt class type:
window.ssoRapport.sidansMermenyConfig =
	euiPopUpMenyClasses.menyConfig.castFrom(window.ssoRapport.sidansMermenyConfig, { castAlsoNestedObjectsAndArrayValues: true });		// "casta" till rätt typ, inkl alla nästade underobjekt/arrayvärden.

function vuexNamespace() {
	switch(window.ssoRapport.reportPart)
	{
		case 'R': return 'resultat';
		case 'T': return 'tillgangar';
		case 'S': return 'skulder';
	}
}

function pageWidgetElementName() {
	switch(window.ssoRapport.reportPart)
	{
		case 'R': return 'resultatrakningwidget';
		case 'T': return 'tillgangarwidget';
		case 'S': return 'skulderwidget';
	}
}


// Todo: Temp.. *kanske*!
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';	// Inspekterbart i web tools flik Performance.


//##############################################################################################################################

//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	store,	// ssoStatestore

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	components: {
		euiMermeny,
	},

	// Data utöver de från mixin ovan:
	data: {
		// Reaktiva data:

		sidansMermenyConfig: window.ssoRapport.sidansMermenyConfig,		// Obs! Denna är tillfixad FÖRE Vue-appen initieras (räcker inte i beforeCreate!)

		selectedMonthId: window.ssoRapport.selectedMonthId,
		menyManad: undefined,		// Sätts i lifecycle hook created, nedan


		// Obs! Nedan: inte reaktiva (read-only) data, medelst användningen av Object.freeze():

		reportPart: Object.freeze(window.ssoRapport.reportPart),

		// Dessa kan freezeas för de används *endast* i Created():
		standardTommaPosterVisas: Object.freeze(window.ssoRapport.standardTommaPosterVisas),
		standardExpanderadeGrupper: Object.freeze(window.ssoRapport.standardExpanderadeGrupper),

		// Ytterligare data finns i ssoStateStore!
	},

	computed: {
		// Computed property functions cannot be arrow functions, because this will be undefined in arrow functions. (The same is true for methods, watches and all lifecycle hooks, btw).

		// Denna extra prop för att kunna användas som v-model (både getter och setter!):
		tommaPosterVisasVmodel: {
			get() { return this.tommaPosterVisas; },
			set(nyttVarde) { this.setTommaPosterVisas(nyttVarde); }
		},

		...mapState(vuexNamespace(), [
			//tommaPosterVisas: state => state.tommaPosterVisas,
			// passing the string value 'count' is same as `state => state.count`
			//'tommaPosterVisas',
			// Med annat namn:
			//annatNamnPatommaPosterVisas: 'tommaPosterVisas',

			'tommaPosterVisas',
			'expanderadeGrupper',

			//gruppExpanderad: state => state.gruppExpanderad,
		]),

		// mix the getters into computed with object spread operator
		...mapGetters(vuexNamespace(), [
			'gruppenArExpanderad',
		]),

		//monthsExceptSelected() {
		//	return this.months.filter((y) => { return y.Id !== this.selectedMonth; });
		//},
	},

	//watch: {
	//	tommaPosterVisas(nyttVarde, tidigareVarde) {
	// Sköts nu i updated():
	//		SetOrUpdateClassOnFirstAndLastNonHiddenChild(this.$_querySelectorAllParentForSetOrUpdateClassOnFirstAndLastNonHiddenChild);
	//	},
	//},

	methods: {
		//...mapMutations([
		//	'increment', // map `this.increment()` to `this.$store.commit('increment')`

		//	// `mapMutations` also supports payloads:
		//	'incrementBy' // map `this.incrementBy(amount)` to `this.$store.commit('incrementBy', amount)`
		//]),
		//...mapMutations({
		//	add: 'increment' // map `this.add()` to `this.$store.commit('increment')`
		//})

		...mapMutations(vuexNamespace(), [
			'setTommaPosterVisas',
			'setExpanderadeGrupper',
			'setGruppExpanderad',
		]),

		onTogglingAvGeneriskKryssruta(skaVisas)
		{
			// Vid klick/toggling på någon av de "generiska kryssrutorna" på sidan (de som inte använder en egen event handler, där detta i så fall *också* måste göras):
			// Detta behövs för att "kryssrutorna" äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
			ssoTooltips.doljAlla();
		},

		onTogglingAvGruppExpanderad(gruppensElementName, nyttVarde)
		{
			// Anledningen att denna finns, och anrop inte istället görs direkt till setGruppExpanderad(), är att här finns lite (ful) extra tillfixning av UI, som är olämplig att placera i store-metoden:

			// Vid klick/toggling på någon av de "generiska kryssrutorna" på sidan:
			// Detta behövs för att "kryssrutorna" äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
			ssoTooltips.doljAlla();

			// Todo: Lite dumt/kostsamt sätt att göra detta på, men...
			this.$nextTick(function () {
				// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
				SetOrUpdateClassOnFirstAndLastNonHiddenChild(this.$_querySelectorAllParentForSetOrUpdateClassOnFirstAndLastNonHiddenChild);
			});

			this.setGruppExpanderad({
					gruppensElementName: gruppensElementName,
					nyttVarde: nyttVarde
				}
			);
		},

		onManadVald({ eventId, eventData })
		{
			switch (eventId) {
				case 'valjManad':
					{
						// Välj en enskild månad:

						this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

						axios.post('/select-month', objectToFormData({
							month: eventData
						}))
							.then(response => {
								// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
								this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

								// Ladda om sidan
								// ???: Kolla om respons är OK först ?
								window.location.reload(true);
							})
							.catch(e => {
								this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;
								// 1) errors är inte definierad under data (eller på annat sätt för 'this'), b) Namnet 'errors' riskerar att krocka med VeeValidate. Undvik!
								// this.errors.push(e);
								console.error(e);
							});
					}
			}
		},

		onMenyalternativValt({ eventId, eventData }) {
			switch (eventId) {
				case 'setCurrentDisposionAsDefaultForCompany':
					{
						//console.log('setCurrentDisposionAsDefaultForCompany', eventId, eventData);

						this.AjaxpostaOchHanteraResultat('/set-current-disposion-as-default-for-company', {
							formData: objectToFormData({
								reportPart: this.reportPart,
								tommaPosterVisas: this.tommaPosterVisas,
								expanderadeGrupperJson: JSON.stringify(this.expanderadeGrupper),
							}),

							doljSpinnerOnSuccess: true,

							onSuccessFunction: (resultat) => {
								// Visa lyckatmeddelande:
								this.$notify({
									group: 'tc',
									text: 'Dispositionen har sparats som standard.',
									type: 'success',
								});
							},

							//withoutSpinner: false,
							//onFailureFunction: undefined,
							//onCatchedErrorFunction: undefined,
						});

						break;
					}

				case 'addPageAsWidget':
					{
						//console.log('addPageAsWidget', eventId, eventData);

						const toPageId = eventData;		// Enkom för tydlighet.

						addPageAsWidget(this, {
							toPageId: toPageId,
							elementName: pageWidgetElementName(),
							parameters: '',
							settings: ''
						});

						break;
					}
			}
		},
	},



	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):

		// Dessa används för att styra funktionalitet i mixin "ssoAllaSidorMixin":
		// Defaultvärde sätts numera i mixinen: this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';
		this.$_vuexNamespace = vuexNamespace();

		this.$_querySelectorAllParentForSetOrUpdateClassOnFirstAndLastNonHiddenChild = '._rrbr_underrader';
	},

	created() {
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.

		if (!NavigatedWithBackOrForward()) {
			// Vid *annan* typ av navigering till sidan än back/forward history "nollas" de till de sparade standardinställningarna:
			this.setTommaPosterVisas(this.standardTommaPosterVisas);
			this.setExpanderadeGrupper(this.standardExpanderadeGrupper);
		}


		let menydelarManad = [];

		for (const month of this.months) {
			let alt = new euiPopUpMenyClasses.delEvent(month.PresentationText, 'valjManad', { ikon: 'rakenskapsar', eventData: month.Id, checked: month.Id === this.selectedMonthId });
			menydelarManad.push(alt);
		}


		this.menyManad = new euiPopUpMenyClasses.menyConfig(menydelarManad);
	},

	updated() {
		//console.log('ssoResultatApp updated!');

		// Todo: Lite dumt/kostsamt sätt att göra detta på, men...
		SetOrUpdateClassOnFirstAndLastNonHiddenChild(this.$_querySelectorAllParentForSetOrUpdateClassOnFirstAndLastNonHiddenChild);
	},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.

		SetOrUpdateClassOnFirstAndLastNonHiddenChild(this.$_querySelectorAllParentForSetOrUpdateClassOnFirstAndLastNonHiddenChild);

		//	this.$nextTick(function () {
		//		// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
		//	});
	},

});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
